import { Injectable } from '@angular/core';
import { ICRUDOptions } from '@phx-erp/shared';
import { BaseListService } from '../../../@core/services/base-list.service';
import { GET_NOT_BACKED_BY_STOCK_DETAILS } from '../../../data/definitions/product-definition';
import { BaseDataService } from '../../../data/services/base-data.service';
import {
    GetNotBackedByStockDetailsQuery,
    GetNotBackedByStockDetailsQueryVariables,
    NotBackedByStockInfo,
    NotBackedByStockSearchInput
} from '../../../generated/generated-types';

@Injectable({
    providedIn: 'root'
})
export class NotBackedByStockService extends BaseListService<NotBackedByStockInfo> {

    constructor(private baseDataService: BaseDataService) {
        super();
    }

    getItems(searchInput?: NotBackedByStockSearchInput, options?: ICRUDOptions) {
        return this.baseDataService.query<GetNotBackedByStockDetailsQuery, GetNotBackedByStockDetailsQueryVariables>(
            GET_NOT_BACKED_BY_STOCK_DETAILS,
            { input: searchInput }
        );
    }
}
